import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getFeeDistributorContract } from '~/contracts/getFeeDistributorContract'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'
import { useVESISParams } from '../../../hooks/useVESISParams'

export function useClaimLock() {
	const { config, provider } = useVESISParams()

	const { signer, account } = useWallet()

	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async () => {
			const contract = getFeeDistributorContract(config, provider).connect(
				signer
			)

			const tx = await contract.claim()

			await tx.wait()
		},
		onSuccess() {
			queryClient.invalidateQueries({
				queryKey: sisTokenKeys.balance(config.chain.id, account),
			})
			queryClient.invalidateQueries({ queryKey: ['sis-lock'] })
		},
		onError(error) {
			console.error('Error claiming lock rewards:', error)
		},
	})
}
